import { FunctionComponent } from 'react';
import Raptor2Loading from '../../feedback/Raptor2Loading';

interface IframeFallbackProps {
  filename: string;
  isPending: boolean;
  pdfUrl: string | null;
}

// Vanilla iframe viewer when react-pdf is unavailable (e.g. Linux) or fails to load.
export const IframeFallback: FunctionComponent<IframeFallbackProps> = ({
  filename,
  isPending,
  pdfUrl,
}) => {
  return (
    <>
      <iframe
        src={pdfUrl ? `${pdfUrl}#zoom=100` : ''}
        width={isPending ? '0%' : '100%'}
        height="100%"
        title={`${filename}.pdf`}
      />
      {isPending ? (
        <Raptor2Loading centerWrap messages={['Generating Document...']} />
      ) : null}
    </>
  );
};
